import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const BRAND = {
  name: "Dotec EW-PDF",
  domain: "itiner3647.it",
  logo: "/dotec-logo.png",
  hero: "https://static.prod-images.emergentagent.com/jobs/abe8b9d6-b879-448a-aee1-25b0c3b18581/images/0a5921ba7e0ba8df7cf7b2b58f54355432a1a24ccf81bb44178c51ab1a04bc90.jpeg",
};

export const XLSX_MIME =
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
export const DOCX_MIME =
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document";

export async function startConversion({ file, mode, instructions, target }) {
  const fd = new FormData();
  fd.append("file", file);
  fd.append("mode", mode);
  fd.append("instructions", instructions || "");
  fd.append("target", target);
  const { data } = await api.post("/convert", fd);
  return data;
}

export async function getJob(jobId) {
  const { data } = await api.get(`/job/${jobId}`);
  return data;
}

export async function pollJob(jobId, { interval = 1500, timeout = 300000, onProgress } = {}) {
  const start = Date.now();
  let failures = 0;
  while (Date.now() - start < timeout) {
    try {
      const job = await getJob(jobId);
      failures = 0;
      if (onProgress) onProgress(job);
      if (job.status === "completed" || job.status === "error") return job;
    } catch (e) {
      failures += 1;
      if (e?.response?.status === 404 || failures >= 4) throw e;
    }
    await new Promise((r) => setTimeout(r, interval));
  }
  const err = new Error("Timeout");
  err.code = "POLL_TIMEOUT";
  throw err;
}

export function apiErrorMessage(e, t) {
  if (e?.code === "POLL_TIMEOUT" || e?.code === "ECONNABORTED") return t.errTimeout;
  const status = e?.response?.status;
  if (status === 413) return t.errTooLarge;
  if (status === 429) return t.errRateLimit;
  if (status >= 500) return `${t.errServer} (HTTP ${status})`;
  if (e?.request && !e?.response) return t.errConnection;
  const detail = e?.response?.data?.detail;
  if (typeof detail === "string" && detail) return detail;
  return e?.message || t.genericError;
}

export async function regenerateExcel(jobId, sheets) {
  const { data } = await api.post(`/regenerate/${jobId}`, { sheets });
  return data;
}

export async function regenerateWord(jobId, blocks) {
  const { data } = await api.post(`/regenerate-word/${jobId}`, { blocks });
  return data;
}

export async function analyzeExcel({ file, mode, instructions, sheet }) {
  const fd = new FormData();
  fd.append("file", file);
  fd.append("mode", mode);
  fd.append("instructions", instructions || "");
  fd.append("sheet", sheet || "");
  const { data } = await api.post("/analyze-excel", fd);
  return data;
}

export async function getExcelSheets(file) {
  const fd = new FormData();
  fd.append("file", file);
  const { data } = await api.post("/excel-sheets", fd);
  return data.sheets || [];
}

export function downloadBase64(b64, filename, mime) {
  const bin = atob(b64);
  const bytes = new Uint8Array(bin.length);
  for (let i = 0; i < bin.length; i++) bytes[i] = bin.charCodeAt(i);
  const blob = new Blob([bytes], { type: mime });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}
